
export default {
  data() {
    return {
      navigationValue: "",
      iconList: [
        {
          id: "receiver",
          text: "Receiver",
          icon: "$receiverMobileIcon",
          to: "/reciever"
        },
        {
          id: "menubook",
          text: "Menubook",
          icon: "$menuMobileIcon",
          to: "/menu"
        },
        {
          id: "reports",
          text: "Reports",
          icon: "$reportsBarIcon",
          to: "/report"
        },
        {
          id: "settings",
          text: "Settings",
          icon: "$settingsIcon",
          to: "/settings/settings-options"
        }
      ]
    };
  }
};
